import { MetaData, PaginatedResponse, Product } from '~shared/models';

export interface SearchResponse {
  products: PaginatedResponse<Product>;
  correction: string;
  recommendedProducts: RecommendedProducts;
  metaData: MetaData;
}

export interface RecommendedProducts {
  items: Product[];
  type: RecommendedProductsType | null;
}

export enum RecommendedProductsType {
  RemovedFilters = 'removedFilters',
  ParentCategory = 'parentCategory',
  ExpandedSearch = 'expandedSearch',
  PromoItems = 'promoItems',
  MostPopularProducts = 'popularProducts',
  MostRelevantProducts = 'mostRelevantProducts',
  ParsedTextProducts = 'parsedText'
}
